module.exports = __webpack_public_path__ + "static/media/arrow_carousel_black.b1929fcc.svg";